if (!customElements.get('before-after')) {
  customElements.define(
    'before-after',
    class BeforeAfter extends HTMLElement {
      connectedCallback() {
        this.pauseButton = this.querySelector('.before-after__pause');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;

        // Static split when auto-play is off or the visitor prefers reduced motion.
        if (this.dataset.autoplay === 'false' || this.reducedMotion.matches) {
          if (this.pauseButton) this.pauseButton.remove();
          return;
        }

        this.onPauseClick = this.togglePaused.bind(this);
        if (this.pauseButton) this.pauseButton.addEventListener('click', this.onPauseClick);

        // Sweep only while in view; leaving the viewport resets the loop so it
        // starts from the left edge again on re-entry. A visitor-initiated pause
        // sticks until they press play again.
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (this.userPaused) return;
              this.classList.toggle('is-autoplaying', entry.isIntersecting);
            });
          },
          { threshold: 0.5 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.pauseButton) this.pauseButton.removeEventListener('click', this.onPauseClick);
      }

      togglePaused() {
        this.userPaused = !this.userPaused;
        this.classList.add('is-autoplaying');
        this.classList.toggle('is-paused', this.userPaused);
        if (this.pauseButton) {
          this.pauseButton.setAttribute(
            'aria-label',
            this.userPaused ? 'Play the before and after comparison' : 'Pause the before and after comparison'
          );
        }
      }
    }
  );
}
